var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8267 0C5.30381 0 0.82666 4.47716 0.82666 10V29.8266C0.82666 35.3494 5.30382 39.8266 10.8267 39.8266H30.6533C36.1761 39.8266 40.6533 35.3494 40.6533 29.8266V10C40.6533 4.47715 36.1761 0 30.6532 0H10.8267ZM13 6H29C32.3137 6 35 8.68629 35 12V28C35 31.3137 32.3137 34 29 34H13C9.68629 34 7 31.3137 7 28V12C7 8.68629 9.68629 6 13 6ZM4 12C4 7.02944 8.02944 3 13 3H29C33.9706 3 38 7.02944 38 12V28C38 32.9706 33.9706 37 29 37H13C8.02944 37 4 32.9706 4 28V12ZM21 25C18.2386 25 16 22.7614 16 20C16 17.2386 18.2386 15 21 15C23.7614 15 26 17.2386 26 20C26 22.7614 23.7614 25 21 25ZM13 20C13 15.5817 16.5817 12 21 12C25.4183 12 29 15.5817 29 20C29 24.4183 25.4183 28 21 28C16.5817 28 13 24.4183 13 20ZM28 11C28 9.89543 28.8954 9 30 9C31.1046 9 32 9.89543 32 11C32 12.1046 31.1046 13 30 13C28.8954 13 28 12.1046 28 11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialInstagram);
export default __webpack_public_path__ + "static/media/social-instagram.0de69da19abe45b70df58587445e69c4.svg";
export { ForwardRef as ReactComponent };